import { gql } from '@apollo/client';

export const GET_REPORT_BY_PROJECT_ID = gql`
  query Reports($projectId: ID!) {
    reports(projectId: $projectId) {
      name
      id
      reportData
      company {
          id
      }
      testSessionNotes {
        id
        videoUrl
      }
      highlightReels {
        id
        videoUrl
      }
    }
  }
`;
